import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/custom-job-titles").GET();

export type GetCustomJobTitlesRes = typeof endpoint.types.Res;

export async function getCustomJobTitles() {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));

    return await call({});
}
